/*jshint esversion: 6 */

// Similar to jQuery's ajax() function.
export default function ajax(options) {
  var xhr = new XMLHttpRequest()
  xhr.open(options.type, options.url, true)
  if (options.contentType) {
    xhr.setRequestHeader('Content-type', options.contentType)
  }
  if (options.withCredentials) {
    xhr.withCredentials = true
  }
  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 400) {
      var data = xhr.responseText && JSON.parse(xhr.responseText)
      if (options.done) {
        options.done(data)
      }
    } else {
      if (options.fail) {
        options.fail(xhr)
      }
    }
    if (options.always) {
      options.always(xhr)
    }
  }
  xhr.onerror = function () {
    if (options.fail) {
      options.fail(xhr)
    }
    if (options.always) {
      options.always(xhr)
    }
  }
  xhr.send(options.data)
}
